<template>
    <div class="c-new-products">
        <div class="c-new-products__header" :ref="'header'">
            <div class="l-container">
                <div class="c-new-products__header__categories">
                    <button
                        v-if="fetchingCategories"
                        v-for="index in 5"
                        class="c-btn is-skeleton"
                        :key="'category-skeleton-' + index"
                    ></button>

                    <button
                        class="c-btn"
                        v-if="!fetchingCategories && categories.length > 0"
                        :class="selectedCategoryId === null ? 'c-btn--primary' : 'c-btn--ghost'"
                        @click="changeSelectedCategory(null)"
                    >
                        {{ $t("NewProducts.AllProducts") }}
                    </button>
                    <button
                        v-for="category in categories"
                        :key="'category-' + category.id"
                        @click="changeSelectedCategory(category.id)"
                        class="c-btn"
                        :class="
                            selectedCategoryId === category.id ? 'c-btn--primary' : 'c-btn--ghost'
                        "
                    >
                        {{ category.name }}
                    </button>
                </div>
                <div class="c-new-products__header__date">
                    <button
                        v-if="fetchingProducts"
                        v-for="index in 5"
                        class="c-btn is-skeleton"
                        :key="'product-skeleton-' + index"
                    ></button>
                    <div class="c-form__item--select" v-if="!fetchingProducts && data.length > 0">
                        <select
                            class="c-form__input"
                            v-model="selectedMonth"
                            @change="changeSelectedMonth"
                        >
                            <option v-for="month in months" :value="month" :key="month">
                                {{ getMonthTitleById(month) }}
                            </option>
                        </select>
                    </div>
                    <button
                        v-if="!fetchingProducts"
                        class="c-btn c-btn--ghost"
                        v-for="weekData in data"
                        @click="scrollToWeek(weekData.week)"
                        :key="'select-' + weekData.week"
                    >
                        <strong>{{ weekData.week }}. {{ $t("NewProducts.week") }}</strong>
                        ({{ formatDate(weekData.dateFrom) }} - {{ formatDate(weekData.dateTo) }})
                    </button>
                </div>
            </div>
        </div>
        <div class="l-container">
            <div class="c-new-products__timeline">
                <div class="c-timeline-week is-skeleton" v-if="!!fetchingProducts">
                    <div class="c-timeline-week__header"></div>
                    <div class="c-timeline-week__products c-listing-products products--grid">
                        <div class="c-listing-products__item" v-for="index in 6">
                            <div class="c-product-thumb is-grid"></div>
                        </div>
                    </div>
                </div>
                <div
                    class="c-timeline-week"
                    v-for="weekData in data"
                    :key="'timeline-' + weekData.week"
                    :ref="'week' + weekData.week"
                >
                    <div class="c-timeline-week__header">
                        <div class="sc-week-number">
                            {{ weekData.week }}.
                            <div class="sc-week-text">{{ $t("NewProducts.week") }}</div>
                        </div>
                        <div class="sc-date">
                            {{ formatDate(weekData.dateFrom) }} -
                            {{ formatDate(weekData.dateTo, true) }}
                        </div>
                    </div>
                    <div class="c-timeline-week__message" v-if="weekData.products.length === 0">
                        <p class="c-msg c-msg--info is-empty">
                            {{ $t("NewProducts.NoNewProducts") }}
                        </p>
                    </div>
                    <div class="c-timeline-week__products c-listing-products products--grid">
                        <div
                            class="c-listing-products__item"
                            v-for="product in weekData.products"
                            :key="weekData.week + '-' + product.id"
                        >
                            <div class="c-product-thumb is-grid">
                                <div class="c-product-thumb__image">
                                    <a class="c-link" :href="product.link" :title="product.name">
                                        <img
                                            alt="Black Tot Last Consignment Mini"
                                            class="c-img entered loaded"
                                            :src="thumbnail(product.image, 'ret-product-thumb-23')"
                                            :alt="product.name"
                                        />
                                    </a>
                                </div>

                                <div class="c-product-thumb__name">
                                    <a class="c-link" :href="product.link" :title="product.name">
                                        <span>{{ product.name }}</span>
                                    </a>
                                </div>
                                <div class="c-product-thumb__price">
                                    <div class="c-price">
                                        <div v-if="product.is_action" class="c-price__old">
                                            {{
                                                formatPrice(
                                                    pricesWithVat
                                                        ? product.old_price_vat
                                                        : product.old_price
                                                )
                                            }}
                                        </div>
                                        <div class="c-price__actual" :class="{'is-action': product.is_action}">
                                            {{
                                                formatPrice(
                                                    pricesWithVat
                                                        ? product.price_vat
                                                        : product.price
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="c-new-products__more"
                v-if="data.length > 0 && selectedMonth !== months[months.length - 1]"
            >
                <button class="c-btn c-btn--secondary-100" @click="showPreviousMonth">
                    {{ $t("NewProducts.ShowPreviousWeeks") }}
                    <i class="ico ico-chevron-down"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";
import { thumbnail } from "./../../functions/thumbnail";
import { formatPrice } from "./../../../../vendor/rshop/frontend/assets/js/common/format";

export default {
    data: () => ({
        fetchCancelToken: null,
        selectedCategoryId: null,
        fetchingCategories: false,
        fetchingProducts: false,
        selectedMonth: null,
        months: [],
        categories: [],
        data: [],
    }),
    created() {
        this.generateMonths();
        this.loadQueryParams();
        this.fetchCategories();
        this.fetchProducts();
    },
    watch: {
        selectedCategoryId() {
            this.updateUrlParams();
        },
        selectedMonth() {
            this.updateUrlParams();
        },
    },
    props: {
        pricesWithVat: {
            type: Boolean,
        },
    },
    methods: {
        loadQueryParams() {
            const urlParams = new URLSearchParams(window.location.search);
            const categoryId = urlParams.get("categoryId");
            const month = urlParams.get("month");

            if (categoryId) {
                this.selectedCategoryId = Number(categoryId);
            }
            if (month) {
                this.selectedMonth = month;
            } else {
                this.selectedMonth = this.months[0];
            }
        },
        updateUrlParams() {
            const queryParams = new URLSearchParams(window.location.search);
            if (this.selectedCategoryId !== null) {
                queryParams.set("categoryId", this.selectedCategoryId);
            } else {
                queryParams.delete("categoryId");
            }

            if (this.selectedMonth) {
                queryParams.set("month", this.selectedMonth);
            } else {
                queryParams.delete("month");
            }

            const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
            window.history.pushState({}, "", newUrl);
        },
        generateMonths() {
            const start = new Date();
            const end = new Date("2015-10-01"); // oldest item

            while (start >= end) {
                const year = start.getFullYear();
                const month = start.getMonth() + 1;
                this.months.push(`${year}-${month}`);
                start.setMonth(start.getMonth() - 1);
            }
            this.selectedMonth = this.months[0];
        },
        getMonthTitleById(id) {
            const [year, month] = id.split("-");

            const monthsMap = {
                1: this.$t("Months.January"),
                2: this.$t("Months.February"),
                3: this.$t("Months.March"),
                4: this.$t("Months.April"),
                5: this.$t("Months.May"),
                6: this.$t("Months.June"),
                7: this.$t("Months.July"),
                8: this.$t("Months.August"),
                9: this.$t("Months.September"),
                10: this.$t("Months.October"),
                11: this.$t("Months.November"),
                12: this.$t("Months.December"),
            };

            return `${monthsMap[Number(month)]} ${year}`; // Return the title based on the ID
        },
        changeSelectedMonth(event) {
            this.data = [];
            this.selectedMonth = event.target.value;
            this.fetchProducts();
        },
        changeSelectedCategory(category) {
            this.data = [];
            this.selectedCategoryId = category ?? null;
            this.fetchProducts();
        },
        scrollToWeek(weekNumber) {
            const targetElement = this.$refs["week" + weekNumber];
            if (targetElement && targetElement[0]) {
                const isMobile = window.innerWidth <= 1023;
                const headerElement = document.querySelector(".l-header");
                const offset = isMobile && headerElement ? headerElement.offsetHeight : 0;

                window.scrollTo({
                    top: targetElement[0].offsetTop - offset,
                    behavior: "smooth",
                });
            }
        },
        formatDate(dateString, includeYear = false) {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            // Conditionally include the year if needed
            return includeYear ? `${day}.${month}.${year}` : `${day}.${month}.`;
        },
        cancelFetchProducts() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel();
            }

            this.fetchCancelToken = CancelToken.source();
        },
        formatPrice(price) {
            return formatPrice(price);
        },
        thumbnail(image, format) {
            return thumbnail(image, format);
        },
        showPreviousMonth() {
            const currentMonthIndex = this.months.indexOf(this.selectedMonth);
            this.selectedMonth = this.months[currentMonthIndex + 1];
            this.scrollToFirstWeek();
            this.fetchProducts();
        },
        scrollToFirstWeek() {
            this.$nextTick(() => {
                const header = this.$refs["header"];
                if (header) {
                    header.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
            });
        },
        fetchCategories() {
            this.fetchingCategories = true;

            client
                .get("/new-products-categories")
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }
                    this.categories = Object.values(response.data.data.items);
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingCategories = false;
                });
        },
        fetchProducts() {
            this.fetchingProducts = true;
            this.cancelFetchProducts();

            client
                .get("/new-products", {
                    cancelToken: this.fetchCancelToken.token,
                    params: {
                        categoryId: this.selectedCategoryId,
                        month: this.selectedMonth,
                    },
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }
                    this.data = Object.values(response.data.data.items);
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingProducts = false;
                });
        },
    },
};
</script>
